import { CounterConfig, CounterType, formatNumber } from '@gripp/shared-logic';
import { t } from 'i18next';
import { FC } from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { MessageComponent, MessageComponentProps } from '../../issue/types';
import { CommonRoutineMessage } from '../components/commonRoutineMessage';
import { routineMessageStyles } from '../components/routineMessageStyles';

export const CounterMessage: MessageComponent = (
  props: MessageComponentProps
) => {
  const assetRoutine = props.message.assetRoutine!;
  const config = assetRoutine.routineVersion.config as CounterConfig;
  const rawCount = assetRoutine?.data?.count;
  const countIsDefined =
    rawCount !== undefined && rawCount !== null && !Number.isNaN(rawCount);
  const count = countIsDefined ? rawCount.toString() : '--';
  const uom = config.uom;
  const rawUser = assetRoutine?.data?.userCount;
  const userValueDefined =
    rawUser !== undefined &&
    rawUser !== null &&
    !Number.isNaN(rawUser) &&
    rawUser !== 0;
  const userValue = userValueDefined
    ? Math.abs(Number(rawUser)).toString()
    : undefined;
  const RoutineTextTypeC =
    RoutineTextType[config?.counterType ?? CounterType.Cumulative];
  const routineText = !userValue ? (
    `${count} ${uom}`
  ) : (
    <RoutineTextTypeC {...props} />
  );

  return <CommonRoutineMessage routineText={routineText} {...props} />;
};

const RoutineText = (props: MessageComponentProps) => {
  const assetRoutine = props.message.assetRoutine!;
  const config = assetRoutine.routineVersion.config as CounterConfig;
  const uom = config.uom;
  const originalRaw = assetRoutine.data?.oldValue;
  const originalValue =
    originalRaw !== undefined &&
    originalRaw !== null &&
    !Number.isNaN(originalRaw)
      ? formatNumber(originalRaw, config.decimalPlaces, true)
      : undefined;
  const userRaw = assetRoutine.data?.userCount;
  const userValue =
    userRaw !== undefined &&
    userRaw !== null &&
    !Number.isNaN(userRaw) &&
    userRaw !== 0
      ? formatNumber(Math.abs(userRaw), config.decimalPlaces, true)
      : undefined;
  const countRaw = assetRoutine?.data?.count;
  const count =
    countRaw !== undefined && countRaw !== null && !Number.isNaN(countRaw)
      ? formatNumber(countRaw, config.decimalPlaces, true)
      : '--';

  return (
    <View>
      {originalValue && (
        <Text style={[routineMessageStyles.text, { display: 'flex' }]}>
          {t('routines.message.originalValue')}: {originalValue} {uom}
        </Text>
      )}
      {userValue && (
        <Text style={[routineMessageStyles.text, { display: 'flex' }]}>
          {`${t(
            `routines.message.${
              assetRoutine.data?.oldValue > assetRoutine.data.count
                ? 'removed'
                : 'added'
            }`
          )}`}
          : {userValue} {uom}
        </Text>
      )}
      <Text style={[routineMessageStyles.text, { display: 'flex' }]}>
        {t('routines.message.newValue')}: {count} {count === '--' ? '' : uom}
      </Text>
    </View>
  );
};

const RoutineSimpleText = (props: MessageComponentProps) => {
  const assetRoutine = props.message.assetRoutine!;
  const config = assetRoutine.routineVersion.config as CounterConfig;
  const uom = config.uom;
  const raw = assetRoutine?.data?.count;
  const count =
    raw !== undefined && raw !== null && !Number.isNaN(raw)
      ? formatNumber(raw, config.decimalPlaces, true)
      : '--';

  return (
    <View>
      <Text style={[routineMessageStyles.text, { display: 'flex' }]}>
        1. {config.instructions}
      </Text>
      <Text style={[routineMessageStyles.text, { display: 'flex' }]}>
        {count} {count === '--' ? '' : uom}
      </Text>
    </View>
  );
};

const CumulativeCounter = (props: MessageComponentProps) => (
  <RoutineText {...props} />
);
const SimpleCounter = (props: MessageComponentProps) => (
  <RoutineSimpleText {...props} />
);
const TallyCounter = (props: MessageComponentProps) => (
  <RoutineText {...props} />
);

type RoutineTextType = FC<MessageComponentProps>;
const RoutineTextType: Record<CounterType, RoutineTextType> = {
  [CounterType.Cumulative]: CumulativeCounter,
  [CounterType.Simple]: SimpleCounter,
  [CounterType.Tally]: TallyCounter,
};
